import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function AllSubjectsIllustration({
  achievementId,
  variant = 'royal',
  // Unlocks royal variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3658" data-mp="1q0z810p0n5ai">
      <div className="relative w-full h-full bg-gradient-to-br from-indigo-900 via-purple-900 to-fuchsia-900 overflow-hidden" data-id="element-3659" data-mp="1ush71j7havsu">
        {/* Background: Golden Mandala / Symbols */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3660" data-mp="1lym32ei3fbes">
          <g className="origin-center animate-[spin_40s_linear_infinite]" style={{
          transformOrigin: '100px 100px'
        }} data-id="element-3661" data-mp="1c0y41cdgfhqt">
            <circle cx="100" cy="100" r="80" stroke="#FBBF24" strokeWidth="2" strokeDasharray="10 10" opacity="0.3" data-id="element-3662" data-mp="eg5c5yui3kxa" />
            <circle cx="100" cy="100" r="60" stroke="#FDE047" strokeWidth="1" opacity="0.2" data-id="element-3663" data-mp="jdorz36uk5rc" />

            {/* Abstract subject symbols arranged in a circle */}
            {[...Array(10)].map((_, i) => {
            const angle = i * 36 * (Math.PI / 180);
            const x = 100 + 70 * Math.cos(angle);
            const y = 100 + 70 * Math.sin(angle);
            return <circle key={i} cx={x} cy={y} r="6" fill="#FBBF24" opacity="0.6" data-id="element-3664" data-mp="38581n7v2e1ca" data-mpi={i} />;
          })}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[5%]" data-id="element-3665" data-mp="170xgbr2k5rr5">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-3666" data-mp="1c09za0qb6eog">
            <DjaySpecimen look={{
            variant,
            accessory: 'scepter'
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3667" data-mp="1gu4ht0u6gnly" />
          </div>
        </div>

        {/* Foreground: Royal Confetti */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3668" data-mp="y10ndd94y6qa">
            <path d="M20 40 L30 45 L25 55 Z" fill="#FDE047" data-id="element-3669" data-mp="29jlbe1tjaajr" />
            <path d="M170 30 L180 35 L175 45 Z" fill="#FDE047" data-id="element-3670" data-mp="2ef8wa50zghjg" />
            <path d="M40 160 L50 165 L45 175 Z" fill="#FBBF24" data-id="element-3671" data-mp="2sylxyn4okbw" />
            <path d="M160 150 L170 155 L165 165 Z" fill="#FBBF24" data-id="element-3672" data-mp="2vb2q8h5gond" />

            <circle cx="50" cy="80" r="3" fill="#A78BFA" data-id="element-3673" data-mp="3u0ucv73icfur" />
            <circle cx="150" cy="100" r="4" fill="#F472B6" data-id="element-3674" data-mp="3p8jgge7z7c6y" />
            <circle cx="100" cy="170" r="3" fill="#38BDF8" data-id="element-3675" data-mp="3p6ymappkpv9m" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}